import styled from 'styled-components'

const DropdownOptionsStyled = styled.div``
export default DropdownOptionsStyled
